<template>
  <v-container fluid>
    <v-card class="mb-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">{{ $t('B1300.title') }}</h3>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="search()"
          class="btn-search"
          v-permit.SHARP_SIP_SEARCH.SHARP_SIB_SEARCH
          >{{ $t('app.buttons.search') }}</v-btn
        >
        <!-- <v-btn @click="excelOpen" v-permit.SHARP_SIP_FROM_DOWNLOAD.SHARP_SIB_FROM_DOWNLOAD>帳票出力</v-btn> -->
        <v-btn
          :disabled="selected.length == 0 || selected.length > 1"
          @click="download"
          v-permit.SHARP_SIP_DOCUMENT_DOWNLOAD.SHARP_SIB_DOCUMENT_DOWNLOAD
          >{{ $t('app.buttons.docDownload') }}</v-btn
        >
        <v-btn @click="downloadBranchDo">検索結果出力</v-btn>
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>

        <v-spacer></v-spacer>
        <v-radio-group
          class="radio_group"
          hide-details
          row
          style="margin-top: 0px"
          v-model="doUnit"
        >
          <v-radio
            :label="$t('B1300.buttons.mother')"
            @click="$router.push('/B1300')"
            value="mother"
          ></v-radio>
          <v-radio :label="$t('B1300.buttons.child')" value="child"></v-radio>
        </v-radio-group>
      </v-card-actions>
    </v-card>

    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    label="ETA"
                    v-model="query.etaFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.etaFrom"
                    label="~"
                    v-model="query.etaTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.productCode')"
                clearable
                v-model="query.productCode"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.ctnNo')"
                clearable
                v-model="query.containerNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.ivNo')"
                clearable
                v-model="query.invNo"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex
              md3
              sm6
              v-if="
                $store.getters.user.roles.every(
                  (r) => r.roleCode !== 'ROLE_PARTNER'
                )
              "
              xs12
            >
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                url="ports/kv"
                v-model="query.dischargePortCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    :label="$t('app.labels.etd')"
                    v-model="query.etdFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.etdFrom"
                    label="~"
                    v-model="query.etdTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    :label="$t('B1300.labels.warehousingDate')"
                    v-model="query.warehousingDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.warehousingDateFrom"
                    label="~"
                    v-model="query.warehousingDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- </v-layout>
            <v-layout row wrap>-->
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.warehouse')"
                url="warehouses/kv"
                v-model="query.finallyWarehouseId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                return-object
                url="divisions/kv?type=BU"
                v-model="query.buHeadquartersId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.department.name')"
                return-object
                url="divisions/kv?type=DEPARTMENT"
                v-model="query.departmentId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.shipName')"
                clearable
                v-model="query.shipName"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    :label="$t('B1300.labels.date1')"
                    v-model="query.etdFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.etdFrom"
                    label="~"
                    v-model="query.etdTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    :label="$t('B1300.labels.date2')"
                    v-model="query.etdFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.etdFrom"
                    label="~"
                    v-model="query.etdTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="B/L No"
                v-model="query.blNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="D/O NO"
                v-model="query.doNo"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>

    <v-card class="mt-2">
      <fixed-column-wrap :data="results">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="results"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[10]"
            :total-items="pagination.totalItems"
            key="id"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.doNo }}</td>
              <td>{{ props.item.branchCode }}</td>
              <td>{{ props.item.blNo }}</td>
              <td>{{ props.item.skuCodes }}</td>
              <td>{{ props.item.skuQty }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.productNames }}</td>
              <td>{{ props.item.partnerName }}</td>
              <td>{{ props.item.invoiceNos }}</td>
              <td style="color: red" v-if="props.item.hasBookingSa">
                {{ props.item.containerNos }}
              </td>
              <td v-if="!props.item.hasBookingSa">
                {{ props.item.containerNos }}
              </td>
              <td>{{ props.item.containerTypeNames }}</td>
              <td>{{ props.item.loadingPortName }}</td>
              <td>{{ props.item.etd }}</td>
              <td>{{ props.item.dischargePortName }}</td>
              <td>{{ props.item.eta }}</td>
              <td>{{ props.item.warehousingDate }}</td>
              <td>{{ props.item.warehousingTime }}</td>
              <td>{{ props.item.forecastDeliveryDate }}</td>
              <td>{{ props.item.forecastDeliveryTime }}</td>
              <td>{{ props.item.finallyWarehouseName }}</td>
              <td>{{ props.item.drakeCompanyName }}</td>
              <td></td>
              <td></td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <download-doc-dialog
      :blNo="selected.length > 0 ? selected[0].blNo : ''"
      ref="DownloadDocDialog"
    ></download-doc-dialog>
    <excel-dialog :shipments="selected" ref="excelDialog"></excel-dialog>
  </v-container>
</template>

<script>
import DownloadDocDialog from '@/components/DownloadDocDialog'
import ExcelDialog from '../B1300/excelDialog'
export default {
  components: {
    DownloadDocDialog,
    ExcelDialog,
  },
  data() {
    return {
      doUnit: 'child',
      showDialog: false,
      selected: [],
      loading: false,
      query: {},
      results: [],
      pagination: {
        page: 1,
      },

      headers: [
        {
          text: 'D/O NO',
          value: 'doNo',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('B1300.labels.branchCode'),
          value: 'branchCode',
          sortable: false,
          class: 'fixed',
        },
        {
          text: 'B/L NO',
          value: 'blNo',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.skuCode'),
          value: 'skuCodes',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.qty'),
          value: 'skuQty',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('B1300.labels.status'),
          value: 'status',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.productCode'),
          value: 'productNames',
          sortable: false,
        },
        {
          text: this.$t('app.labels.partner'),
          value: 'partnerName',
          sortable: false,
        },
        {
          text: 'I/V NO',
          value: 'invoiceNos',
          sortable: false,
        },
        {
          text: this.$t('app.labels.ctnNo'),
          value: 'containerNos',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.ctnSize'),
          value: 'containerTypeNames',
          sortable: false,
        },
        {
          text: this.$t('app.labels.loadingPort'),
          value: 'loadingPortCode',
          sortable: false,
        },
        {
          text: 'ETD',
          value: 'etd',
          sortable: false,
        },
        {
          text: this.$t('app.labels.dischargePort'),
          value: 'dischargePortCode',
          sortable: false,
        },
        {
          text: 'ETA',
          value: 'eta',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.warehousingDate'),
          value: 'warehousingDate',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.warehousingTime'),
          value: 'warehousingTime',
          sortable: false,
        },
        {
          text: this.$t('app.labels.forecastDeliveryDate'),
          value: 'forecastDeliveryDate',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.forecastDeliveryTime'),
          value: 'forecastDeliveryTime',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.finallyWarehouseName'),
          value: 'finallyWarehouseName',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.drakeCompanyName'),
          value: 'drakeCompanyName',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.date1'),
          value: 'date1',
          sortable: false,
        },
        {
          text: this.$t('B1300.labels.date2'),
          value: 'date2',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    downloadBranchDo() {
      this.$http
        .get('/display-status?branchNeedParam=true', {
          params: {
            ...this.query,
            ...this.$pageable(),
            size: 99999,
            page: 0,
          },
        })
        .then((res) => {
          console.log(res.data.content)
          this.$exportTable(
            res.data.content,
            this.headers.map((h) => h.value),
            this.headers.map((h) => h.text),
            '枝番CSV出力'
          )
        })
    },
    excelOpen() {
      this.$refs.excelDialog.popup()
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/display-status/branch', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    closeEvent(value) {
      this.showDialog = value
    },
    containerNos(item) {
      return item.packages
        .map((p) => p.containerNo)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    containerTypes(item) {
      return item.packages
        .map((p) => p.containerTypeName)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    skuCodes(skuCodes) {
      return skuCodes && skuCodes.split(',', 3).join(',')
    },
    productName(item) {
      return item.packages
        .map((p) => p.productName)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    invNo(item) {
      return item.packages
        .map((p) => p.invoiceNo)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    download() {
      this.$refs.DownloadDocDialog.popup()
    },
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
    doUnit() {
      if (this.doUnit == 'mother') {
        this.$router.push('/B1300')
      }
    },
  },
}
</script>
